const styles = {
  root: {
    padding: 0
  }
};

export default styles